import TaxonomyDropdown from './components/TaxonomyDropdown';
import UserTaxonomyPage from './components/UserTaxonomyPage';
import showsFilterFor from './utils/showsFilterFor';

export const forum = {
    'components/TaxonomyDropdown': TaxonomyDropdown,
    'components/UserTaxonomyPage': UserTaxonomyPage,
    'utils/showsFilterFor': showsFilterFor,
}
